import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { collectionOrderService } from '../../services/collection-order.service'

export interface CollectionOrderResponse {
  CollectionOrderId: number
  Status: number
  BankName: string
  PrincipalValue: number
  Token: string
  PayerPhone?: string
  CreationDate?: string
}

export interface CollectionOrderState {
  collectionOrders: CollectionOrderResponse[]
  loading: boolean
  error: string | null
  pagination: {
    currentPage: number
    pageSize: number
    totalItems: number
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
  } | null
}

const initialState: CollectionOrderState = {
  collectionOrders: [],
  loading: false,
  error: null,
  pagination: null,
}

export const fetchCollectionOrdersPaged = createAsyncThunk(
  'dailySale/fetchCollectionOrdersPaged',
  async (params: {
    pageIndex: number
    pageSize: number
    status?: number
    startDate?: string
    endDate?: string
    token?: string
  }) => {
    try {
      const response = await collectionOrderService.getCollectionOrdersPaged(
        params.pageIndex,
        params.pageSize,
        params.status,
        params.startDate,
        params.endDate,
        params.token,
      )
      return response
    } catch (error) {
      throw error
    }
  },
)

const collectionOrderSlice = createSlice({
  name: 'dailySale',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null
    },

    clearCollectionOrder(state) {
      state.collectionOrders = []
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCollectionOrdersPaged.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCollectionOrdersPaged.fulfilled, (state, action) => {
        state.loading = false
        state.collectionOrders = action.payload.data
        state.pagination = action.payload.pagination
      })
      .addCase(fetchCollectionOrdersPaged.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.error.message || 'Error al cargar datos. Inténtalo nuevamente.'
      })
  },
})

export const { clearError, clearCollectionOrder } = collectionOrderSlice.actions
export default collectionOrderSlice.reducer
